import React, { Component } from "react"
import { split, flatMap, sample } from "lodash"
import fetch from "cross-fetch"
import moment from "moment"
import queryString from "query-string"

import Button from "../button"
import * as Icon from "react-feather"
import EventGroup from "../event-group"
import EventsFilter from "../event-filter"
import Loader from "../loader"
import countries from "../../helpers/countries"
import EventsConfig from "../../helpers/eventsConfig"
import storyblokLinkHandler from "../../helpers/storyblokLinkHandler"
import SbImageService, { isSvg } from "../../helpers/SbImageService"

const buildSearchQuery = (search) => {
  const searchWords = split(search, " ")
  return `${searchWords.join("* | ")}*`
}

class EventDiscovery extends Component {
  page = 0
  size = 6

  state = {
    loading: true,
    search: "",
    offset: 0,
    total: 0,
    upComingEvents: [],
    userCountries: [],
    programs: [],
    types: [],
    showFilters: false,
    landingCountryCode: "",
  }

  async componentDidMount() {
    const { userCountries } = this.state

    const countryFilter = {
      field: "Country",
      options: [userCountries.length > 0 ? userCountries : "get_location"],
    }
    const query = queryString.parse(window.location.search)
    const { eventtype, program, country } = query
    let upComingSearch

    if (
      typeof window !== "undefined" &&
      window.location.search &&
      (eventtype || program || country)
    ) {
      this.redirect()
    } else {
      upComingSearch = await this.search([countryFilter])
    }
    this.setState({
      ...upComingSearch,
    })
  }

  redirect = () => {
    const { eventsResultsUrl } = this.props.eventsConfig
    const query = queryString.parse(window.location.search)
    const { eventtype, program, country } = query

    if (eventtype || program || country) {
      window.location.href = `${storyblokLinkHandler(eventsResultsUrl)}${
        window.location.search
      }`
    }
  }

  eventFormater = (eventArr, imgObj) => {
    const { fallbackEvent } = this.props.eventsConfig

    const formattedEvents =
      eventArr.length > 0
        ? eventArr.map(
            (event, index) =>
              event && {
                date:
                  moment
                    .utc(event.StartDatetime)
                    .format("llll")
                    .split(" ")
                    .slice(0, -2)
                    .join(" ") || "",
                url: event.Link,
                name: event.Title,
                location:
                  event.Region === "Global"
                    ? "Available Worldwide"
                    : countries[event.Country],
                image: this.imgHandler(event, imgObj),
                tags: this.programTagHandler(event.Programs),
              }
          )
        : []

    if (eventArr.length < 6) {
      formattedEvents.push({
        url: fallbackEvent[0].url,
        name: fallbackEvent[0].title,
        image: fallbackEvent[0].image,
        description: fallbackEvent[0].description,
      })
      return formattedEvents
    }

    return formattedEvents
  }

  imgHandler = (event) => {
    const { specifyEventImage, eventTypeImages } = this.props.eventsConfig
    const { Type, Id } = event
    const eventType = Type === "121" ? "One-to-One" : Type
    const eventId = Id.split("-")[0]
    const { img } = eventTypeImages.filter(
      (imgType) => eventType.toLowerCase() === imgType.type.toLowerCase()
    )[0]
    const specImg =
      specifyEventImage.filter((img) => img.eventId === eventId) || []

    if (specImg.length > 0) {
      return sample(specImg).image
    }
    return sample(img).image
  }

  search(filters, size) {
    this.page += 1
    const { search, offset } = this.state

    return fetch(`${process.env.GATSBY_HULTEDUDATA_API}/events/search`, {
      method: "POST",
      body: JSON.stringify({
        from: offset,
        size: size || this.size,
        search: buildSearchQuery(search),
        filters,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (res.status >= 400) {
          throw new Error("Bad response from server")
        }
        return res.json()
      })
      .then((result) => {
        return {
          upComingEvents: this.eventFormater(
            flatMap(result.hits.hits, (f) => f._source)
          ),
          userCountries: result.location ? [result.location] : [],
          landingCountryCode: result.location,
          loading: false,
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }

  countryCodeToName = (codeArr) => {
    return codeArr.map((code) => countries[code])
  }

  hrefHandler = () => {
    const { userCountries, programs, types } = this.state

    let paramsArr = []

    types.length > 0 && paramsArr.push(`eventtype=${this.formatParams(types)}`)

    programs.length > 0 &&
      paramsArr.push(`program=${this.formatParams(programs)}`)

    userCountries.length > 0 &&
      paramsArr.push(
        `country=${this.formatParams(this.countryCodeToName(userCountries))}`
      )

    return paramsArr.length > 0 ? `?${paramsArr.join("&")}` : ""
  }

  formatParams = (arr) => arr.join(",").replace(/\s/g, "%20")

  programTagHandler = (programArr) => {
    return programArr.map((code) => {
      const programArr = this.props.eventsConfig.programList.filter(
        (listProg) => code === listProg.value
      )
      return programArr.length === 1 ? programArr[0].name : ""
    })
  }

  programHandler = (event) => {
    const { name } = event.target
    const { programs } = this.state

    this.setState({
      programs: this.filterHandler(name, programs),
    })
  }

  filterHandler = (value, arr) => {
    let arrCopy = arr

    switch (true) {
      case !value:
        arrCopy = []
        break
      case arr.includes(value):
        arrCopy = arrCopy.filter((e) => e !== value)
        break
      default:
        arrCopy.push(value)
    }
    return arrCopy
  }

  typesHandler = (event) => {
    const { value } = event.target
    const { types } = this.state

    this.setState({
      types: this.filterHandler(value, types),
    })
  }

  locationHandler = (event) => {
    const { value } = event.target
    const { userCountries } = this.state

    this.setState({
      userCountries: this.filterHandler(value, userCountries),
    })
  }

  toggleFilters = () => {
    const { showFilters } = this.state

    this.setState({
      showFilters: !showFilters,
    })
    window.scrollTo(0, 0)
  }

  render() {
    const {
      upComingEvents,
      userCountries,
      programs,
      types,
      showFilters,
      loading,
      landingCountryCode,
    } = this.state

    const { eventsResultsUrl, eventTypeList } = this.props.eventsConfig

    const { cardTitle, eventCards } = this.props.blok

    return (
      <>
        <Button
          className="btn--wide btn--cta event-discovery__filter-btn"
          text="Filter events"
          iconName="Filter"
          onClick={this.toggleFilters}
        />
        <div
          className={`event-discovery__filters ${
            showFilters ? "event-discovery__filters--visible" : ""
          }`}
        >
          <div className="event-discovery__filters-container">
            <header className="event-discovery__filters-header">
              <Icon.X
                className="event-discovery__filters-icon icon icon--sm"
                onClick={this.toggleFilters}
              />
              <p className="event-discovery__filters-title">Filter events</p>
            </header>
            {eventTypeList && (
              <EventsFilter
                href={`${storyblokLinkHandler(
                  eventsResultsUrl
                )}${this.hrefHandler()}`}
                onProgramChange={this.programHandler}
                onTypeChange={this.typesHandler}
                onCountryChange={this.locationHandler}
                location={userCountries}
                programList={this.props.eventsConfig.programList}
                selectedProgram={
                  programs.length > 1 ? `${programs[0]}...` : programs[0]
                }
                programsArr={programs.map(
                  (prog) =>
                    this.props.eventsConfig.programList.filter(
                      (listProg) => listProg.name === prog
                    )[0].value
                )}
                countriesList={countries}
                selectedLocation={
                  userCountries.length > 1
                    ? `${countries[userCountries[0]]}...`
                    : countries[userCountries[0]]
                }
                countriesArr={userCountries}
                typesList={eventTypeList}
                selectedType={
                  types.length > 0 &&
                  `${types[0] === "121" ? "One-to-One" : types[0]}
                  ${types.length > 1 ? "..." : ""}`
                }
                typesArr={types}
              />
            )}
          </div>
        </div>
        {!loading ? (
          <div className="event-discovery">
            <EventGroup
              name={`Upcoming events  ${
                landingCountryCode ? `in ${countries[landingCountryCode]}` : ""
              }`}
              eventArr={upComingEvents}
              url={`${storyblokLinkHandler(eventsResultsUrl)}${
                userCountries
                  ? `?country=${this.countryCodeToName(userCountries)}`
                  : ""
              }`}
            />
          </div>
        ) : (
          <Loader />
        )}
        {eventCards && (
          <div className="event-group">
            <header className="event-group__header">
              <p className="event-group__name">{cardTitle}</p>
            </header>
            <div className="event-group__list event-group__list--carousel">
              {eventCards.map((event, index) => (
                <div className="event-group__item" key={index}>
                  <a href={storyblokLinkHandler(event.url)}>
                    <div
                      className="lazyload event-item event-item--type"
                      data-bg={SbImageService(event.image)}
                      style={
                        isSvg(event.image)
                          ? { backgroundImage: `url("${event.image}")` }
                          : null
                      }
                    >
                      <div className="event-item__type-inner">
                        <p className="event-item__name">{event.title}</p>
                        <p className="event-item__type-desc">
                          {event.description}
                        </p>
                      </div>
                    </div>
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}
      </>
    )
  }
}

export default EventsConfig(EventDiscovery)
